module.exports = __webpack_public_path__ + "img/logo.ad7a4b0c.png";